<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
     <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <b-container fluid="">
      <b-row>
        <b-col>
          <b-card header-tag="header">
            <template #header>
              <card-title>
                <b-icon class="icono" icon="file-text"></b-icon>Sesiones Realizadas
              </card-title>
            </template>
            <b-card-body class="scrollx">
              <b-row>  
                <b-col> 
                </b-col>
                 <b-col> 
                </b-col>
              </b-row>
              
              <b-row>
                <b-col>  
                  <b-table thead-tr-class="columnas" class="parrafos" hover id="tratamientos" :items="tratamientossesion" :fields="fields" :per-page="registrosPorPagina"  :current-page="paginaActual">
                    <template v-slot:cell(fechaAlta)="row">
                      <div>{{row.item.fechaAlta | formatoFechaHoraTexto }}</div>
                    </template>
                    <template v-slot:cell(numeroDiente)="row">
                      <div>{{ (row.item.numeroDiente === null ||row.item.numeroDiente==="")?"Boca completa": row.item.numeroDiente}}</div>
                    </template>
                    <template v-slot:cell(numeroRecibo)="row">
                      <div>{{ (row.item.numeroRecibo === null ||row.item.numeroRecibo==="")?"Sin dato": row.item.numeroRecibo}}</div>
                    </template>
                  </b-table>
                  <b-pagination
                      v-if="tratamientossesion !== undefined && tratamientossesion.length > 15"
                      align="center"
                      v-model="paginaActual"
                      :total-rows="tratamientossesion.length"
                      :per-page="registrosPorPagina"
                      aria-controls="tratamientos"
                  ></b-pagination>
                  <div align="center" v-if="loaderTratamientossesion">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                  </div>
                  <div v-if="tratamientossesion.length === 0 && loaderTratamientossesion===false" align="center">
                    <b-alert show variant="warning">No hay datos</b-alert>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: "sesionesRealizadas",
  components: {
  },
  props:{
    idPaciente: null,
  },

  data:() => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    loaderTratamientossesion:false,
    tratamientossesion: [],
    currentPage: 1,
    registrosPorPagina: 15,
    paginaActual: 1,
    fields: [
    {key: "clasificacionTx", label: "Origen del tx", sortable: true},
      {key: "fechaAlta", label: "Fecha Sesión", sortable: true},
      {key: "strNombre", label: "Nombre clinica de sesión", sortable: true},
      {key: "nombreCompleto", label: "Doctor Sesión", sortable: true},
      {key: "tratamiento", label: "Tratamiento", sortable: true},
      {key: "numeroSesion", label: "Núm. sesión", sortable: true},
      {key: "numeroDiente", label: "OD", sortable: true},
      {key: "numeroRecibo", label: "Núm. recibo", sortable: true}
    ],
    loading : false,
  }),

  created() {
    this.debug = this.$localStorageService.getDebug();

  },
  mounted(){
    this.obtenerSesionesRealizadas();
  },
  methods:{
    /**
     * Funcion para obtener las sesiones realizadas
     */
    obtenerSesionesRealizadas(){
      this.loaderTratamientossesion = true;
      this.tratamientossesion = [];
      const parametros = {idPaciente: this.idPaciente}
      this.$http.post(this.$api + "tratamiento_sesion/obtenerSesionesRealizadas", parametros)
         .then((response) => {
           if(response.data.data){
             let resultado = response.data.data;
             resultado.forEach(it => {
               this.paginaActual=1;
               this.tratamientossesion.push(it);
             });
           }
           this.loaderTratamientossesion = false;
         }).catch(function(error){
           console.error(error);
           this.loaderTratamientossesion = false;
         });
     },

     
  },

};
</script>

<style>
</style>
